import {
	Command,
	EditorState,
	Transaction
} from "prosemirror-state";
import { getNodesWithPositionFromSelection, NodeWithPosition } from "../utils";
import { Schema } from "prosemirror-model";

export function removeLinkAtSelection(schema: Schema<never, "link">): Command {
	return (
		state: EditorState,
		dispatch: ((tr: Transaction) => void) | undefined
	): boolean => {
		const nodesFromSelection: readonly NodeWithPosition[] = getNodesWithPositionFromSelection(
			state,
			{
				markType: schema.marks.link
			}
		);

		if (nodesFromSelection.length === 0) {
			return false;
		}

		if (dispatch) {
			const {
				from,
				to
			} = state.selection;

			let minPosition: number = from;
			let maxPosition: number = to;

			for (const nodeWithPosition of nodesFromSelection) {
				const from = nodeWithPosition.position;
				const to = nodeWithPosition.position + nodeWithPosition.node.nodeSize;
				minPosition = Math.min(minPosition, from);
				maxPosition = Math.max(maxPosition, to);
			}
			const tr: Transaction = state.tr;
			tr.removeMark(minPosition, maxPosition, schema.marks.link);
			tr.scrollIntoView();
			dispatch(tr);
		}

		return true;
	};
}